import type { Opportunity } from '@axiom/validation';
import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

class SyncApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createSync(opportunityId: Opportunity['id']) {
    return super.write<{ data: null }>({
      endpoint: `/sync/opportunities/${opportunityId}`,
      method: 'POST',
    });
  }
}

export const SyncOpportunityApi = new SyncApiClass();
